import { Bell, LogOut, RefreshCw, Menu } from 'lucide-react'
import { useAuthStore } from '@/store/authStore'
import { useNavigate } from 'react-router-dom'
import { format } from 'date-fns'
import { ru } from 'date-fns/locale'

export default function Topbar({ onMenuClick }) {
  const logout = useAuthStore((s) => s.logout)
  const navigate = useNavigate()
  const today = format(new Date(), 'EEEE, d MMMM yyyy', { locale: ru })

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <header className="bg-white border-b border-gray-200 px-4 md:px-6 py-3 flex items-center justify-between gap-3">
      <div className="flex items-center gap-3 min-w-0">
        <div className="md:hidden flex items-center gap-2 mr-2">
          {/* Mobile branding */}
          <div className="w-8 h-8 flex items-center justify-center bg-primary-600 rounded-lg shrink-0">
            <span className="text-white font-bold text-xs">SK</span>
          </div>
          <p className="font-bold text-gray-900 text-sm">СКУД CRM</p>
        </div>
        <p className="text-gray-500 text-sm capitalize truncate hidden md:block">{today}</p>
      </div>

      <div className="flex items-center gap-1 shrink-0">
        <button
          onClick={() => window.location.reload()}
          className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
          title="Обновить"
        >
          <RefreshCw size={18} />
        </button>
        <button
          className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors relative"
          title="Уведомления"
        >
          <Bell size={18} />
        </button>
        <button
          onClick={handleLogout}
          className="flex items-center gap-1.5 px-2 md:px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-colors"
        >
          <LogOut size={16} />
          <span className="hidden sm:inline">Выйти</span>
        </button>
      </div>
    </header>
  )
}
